<template>
    <div class="main-container">
        <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
        <!-- breadcrumb -->

        <section class="main-content-section">
            <tl-tabs :tabs="tabs" :selected="tabIndex">
                <tl-tab>
                    <create-salary-structure @changeTabIndex="getIndex($event)"></create-salary-structure>
                </tl-tab>
                <tl-tab>
                    <saved-salary-structure @changeTabIndex="getIndex($event)"></saved-salary-structure>
                </tl-tab>
            </tl-tabs>
        </section>
    </div>
</template>

<script>
import createSalaryStructure from './createSalaryStructure.vue';
import savedSalaryStructure from './savedSalaryStructure.vue';
import { log } from 'util';

export default {
  name: 'SalaryStructure',
  components: {
      createSalaryStructure,
      savedSalaryStructure
  },
  data() {
      return {
        tabIndex:1,
        breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Salary Structure",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarystructure`
              }
        ],
        tabs: [{
          header: 'Create Salary Structure'
        },
        {
          header: 'Saved Salary Structure'
        }
      ]
      }
  },
  computed: {
      
  },
  methods: {
      getIndex(val){
          //console.log(val);
          this.tabIndex = val;
         // this.$emit('changeParentTabIndex', val);
      }
  }
}
</script>
<style lang="scss" scoped>

</style>
